var $ = jQuery.noConflict();

$(window).on('load', function () {
    let method = 'front';
    if ($('body').hasClass('wp-admin'))
        method = 'wp-admin';

    const initializeBlock = function ($block) {

        const listItems = document.querySelectorAll('.block-cta-with-tabs__list li a');
        const tabs = document.querySelectorAll('.block-cta-with-tabs__tab');

        const setTabHeight = () => {
            const tabsWrapper = document.querySelector('.block-cta-with-tabs__tabs');
            const heightArray = []
            tabs.forEach((tab) => {
                heightArray.push(tab.offsetHeight);
            })
            const highestTab = Math.max(...heightArray)
            return tabsWrapper.style.height = `${highestTab}px`
        }


        const setActiveElement = (activeElement) => {
            const activeElementId = activeElement.dataset.id

            listItems.forEach(item => item.classList.remove('active'))
            activeElement.classList.add('active')
            tabs.forEach((tab) => {
                if (tab.dataset.id === activeElementId) {
                    tabs.forEach(tab => tab.classList.remove('block-cta-with-tabs__tab--active'))
                    tab.classList.add('block-cta-with-tabs__tab--active');
                }
            })
        }

        setTabHeight()
        window.addEventListener('resize', setTabHeight);

        listItems.forEach((item) => {
            item.addEventListener('click', function () {
                setActiveElement(this)
            })
        })


        // switch dropdown
        jQuery('.block-cta-with-tabs__select .select2-init').change(function () {
            let val = jQuery(this).val();
            jQuery('.block-cta-with-tabs__tab').removeClass('block-cta-with-tabs__tab--active');
            jQuery('.block-cta-with-tabs__tab[data-id="' + val + '"]').addClass('block-cta-with-tabs__tab--active');
            jQuery('.block-cta-with-tabs__list li a').removeClass('active');
            jQuery('.block-cta-with-tabs__list li a[data-id="' + val + '"]').addClass('active');
        });

        jQuery('.block-cta-with-tabs__list li').each(function(){
            if(jQuery(this).height() > 30){
                jQuery(this).css('margin-bottom', '2.3rem');
            }
        });
    };

    window.onload = function () {
        initializeBlock($(this));
    }();

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=cta-with-tabs', initializeBlock);
    }
});
